// Admin client with service role key to bypass RLS policies
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { config } from '@/config/env';

// Create admin client with service role key for operations that need to bypass RLS
export const supabaseAdmin = createClient<Database>(
  config.supabase.url,
  config.supabase.serviceRoleKey || config.supabase.anonKey, // Fallback to anon key if service role not available
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false,
    },
    global: {
      headers: {
        'X-Client-Info': 'brutt-admin-console-admin',
      },
    },
  }
);

// Check if we have a service role key (which bypasses RLS)
export const hasServiceRoleKey = () => {
  return !!config.supabase.serviceRoleKey;
};

// Helper function to check if admin client is properly configured
export const isAdminClientConfigured = () => {
  return config.supabase.url && (config.supabase.serviceRoleKey || config.supabase.anonKey);
};
